import { AgGridColumn } from 'ag-grid-react';
import React from 'react';
import { List } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';
import { ConnectedHcpGridWithGQL } from '.';
import { useGetPatientDispensesQueryQuery } from '../graphql';
import {
  carrierColumnDefinition,
  dateColumnDefinition,
  prescriberColumnDefinition,
  trackingColumnDefinition,
  generalColumnDefinition,
  globalDefaultColDefs
} from '../utils';

export const DispensesTable = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <div className='h5 cmx__profile-tab-title' style={{ fontSize: 24, fontWeight: 700 }}>
        PATIENT DISPENSES
      </div>
      <ConnectedHcpGridWithGQL
        queryHook={useGetPatientDispensesQueryQuery}
        queryOptions={{
          variables: {
            patientId: id
          }
        }}
        overlayNoRowsTemplate={'<span style="padding: 10px;">You currently have no dispenses for this patient.</span>'}
        pagination>
        <AgGridColumn
          {...dateColumnDefinition('shippedDate')}
          headerName='Shipped'
          resizable={true}
          {...generalColumnDefinition()}
        />
        <AgGridColumn field='pharmacyName' headerName='Pharmacy' resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn field='productName' headerName='Product' resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn field='dispenseType' headerName='Type' resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn field='quantity' headerName='Quantity' resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn field='fillNumber' headerName='Fill#' resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn field='refillRemaining' headerName='Refills' resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn {...carrierColumnDefinition('Carrier')} resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn {...trackingColumnDefinition('Tracking')} resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn {...prescriberColumnDefinition('Provider')} resizable={true} {...generalColumnDefinition()} />
        <AgGridColumn field='physicianNpi' headerName='Provider NPI' resizable={true} {...generalColumnDefinition()} />
      </ConnectedHcpGridWithGQL>
    </>
  );
};
